module.exports = `${require.publicPath}footer-img02.a37bfbde.png`;